export default __webpack_public_path__ + "static/media/prev-MDS-2.214d0d92.png";